/** 商行详情 — 热敏小票打印模板共用字段、默认值与数据转换 */

export const STALL_THERMAL_PRINTER_TAB_KEY = '20';

export const STALL_THERMAL_PRINTER_MEMO_EDIT_PATH =
  '/booth/stallManager/stallManagementDetail/stallThermalPrinterMemoEdit';

export const STALL_THERMAL_PRINTER_ORDER_EDIT_PATH =
  '/booth/stallManager/stallManagementDetail/stallThermalPrinterOrderEdit';

export const FONT_SIZE_VALUE = {
  MINI: 1,
  SMALL: 2,
  NORMAL: 3,
  LARGE: 4,
  XLARGE: 5,
};

export const FONT_SIZE_OPTIONS = [
  { value: FONT_SIZE_VALUE.MINI, label: '迷你' },
  { value: FONT_SIZE_VALUE.SMALL, label: '小号' },
  { value: FONT_SIZE_VALUE.NORMAL, label: '常规' },
  { value: FONT_SIZE_VALUE.LARGE, label: '大号' },
  { value: FONT_SIZE_VALUE.XLARGE, label: '超大号' },
];

export const FONT_SIZE_TO_LINE_CHARS = {
  1: 24,
  2: 20,
  3: 16,
  4: 12,
  5: 8,
};

export const THERMAL_PREVIEW_CONTENT_WIDTH = 320;
export const FONT_SIZE_TO_PX = Object.keys(FONT_SIZE_TO_LINE_CHARS).reduce((acc, key) => {
  acc[key] = Number((THERMAL_PREVIEW_CONTENT_WIDTH / FONT_SIZE_TO_LINE_CHARS[key]).toFixed(4));
  return acc;
}, {});

export const DEFAULT_FIELD_FONT_SIZE = FONT_SIZE_VALUE.NORMAL;
export const DEFAULT_TITLE_FONT_SIZE = FONT_SIZE_VALUE.NORMAL;

export const THERMAL_STYLE_MODE = {
  TEXT: 'text',
  TABLE: 'table',
};

export const MEMO_HEAD_FIELDS = [
  { key: 'memoNo', label: '码单号', defaultPrint: true },
  {
    key: 'stallName',
    label: '商行名称',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.LARGE,
    defaultBold: true,
    align: 'center',
  },
  {
    key: 'buyerName',
    label: '客户名称',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
  },
  { key: 'buyerAddress', label: '客户地址' },
  {
    key: 'plateNumber',
    label: '车牌',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: false,
  },
  { key: 'orderRemark', label: '备注', defaultPrint: true },
];

export const MEMO_PRODUCT_FIELDS = [
  {
    key: 'productName',
    label: '货品',
    required: true,
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    align: 'left',
  },
  { key: 'packWeight', label: '规格', align: 'left' },
  {
    key: 'saleNumberWeight',
    label: '数量/重量',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    align: 'left',
  },
  { key: 'packStatus', label: '配货量', align: 'left' },
  { key: 'unitPrice', label: '单价', align: 'left' },
  { key: 'goodsAmount', label: '货款', align: 'left' },
  { key: 'productRemark', label: '单品备注', align: 'left' },
  { key: 'basketDesc', label: '押筐', align: 'left' },
];

export const MEMO_TOTAL_FIELDS = [
  {
    key: 'totalNumberWeight',
    label: '总数量/总重量',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  { key: 'totalGoodsAmount', label: '总货款', defaultBold: true, align: 'left' },
  { key: 'tradeFee', label: '力资费', defaultBold: true, align: 'left' },
  { key: 'chargeOrderFee', label: '三轮车费', defaultBold: true, align: 'left' },
  { key: 'totalAmount', label: '总计', defaultBold: true, align: 'left' },
];

export const MEMO_END_FIELDS = [
  { key: 'createName', label: '开票员', defaultPrint: true, defaultFontSize: FONT_SIZE_VALUE.MINI },
  {
    key: 'createTime',
    label: '开票时间',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  {
    key: 'deliveryDate',
    label: '送达日期',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  {
    key: 'marketName',
    label: '市场名称',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  { key: 'stallTelephone', label: '联系方式', defaultFontSize: FONT_SIZE_VALUE.MINI },
  {
    key: 'advertising',
    label: '广告语',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
    align: 'center',
  },
];

export const ORDER_HEAD_FIELDS = [
  {
    key: 'voucherName',
    label: '凭证名称',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.LARGE,
    defaultBold: true,
  },
  { key: 'todayNo', label: '票号', defaultPrint: true },
  { key: 'memoNo', label: '码单号', defaultPrint: true },
  { key: 'marketName', label: '市场名称', defaultPrint: true, align: 'center' },
  {
    key: 'stallName',
    label: '商行名称',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.LARGE,
    defaultBold: true,
    align: 'center',
  },
  {
    key: 'buyerName',
    label: '客户名称',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
  },
  {
    key: 'buyerPhone',
    label: '客户电话',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
  },
  { key: 'buyerAddress', label: '客户地址' },
  {
    key: 'plateNumber',
    label: '车牌',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: false,
  },
  { key: 'orderRemark', label: '备注', defaultPrint: true },
  {
    key: 'deliveryTime',
    label: '送达日期',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
  },
  {
    key: 'printCount',
    label: '打印次数',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
];

export const ORDER_PRODUCT_FIELDS = [
  {
    key: 'productName',
    label: '货品',
    required: true,
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: false,
    align: 'left',
  },
  { key: 'packWeight', label: '规格', align: 'left' },
  { key: 'orderNumber', label: '下单量', align: 'left' },
  { key: 'saleNumber', label: '销量', defaultPrint: true, align: 'left' },
  { key: 'grossWeight', label: '毛重/皮重', defaultPrint: true, align: 'left' },
  { key: 'iceWeight', label: '去皮', defaultPrint: true, align: 'left' },
  { key: 'unitPrice', label: '单价', defaultPrint: true, align: 'left' },
  { key: 'goodsAmount', label: '货款', align: 'left' },
  {
    key: 'subtotal',
    label: '小计',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: false,
    align: 'left',
  },
  { key: 'basketDesc', label: '押筐', defaultPrint: true, align: 'left' },
  { key: 'extraAmount', label: '附加费', defaultPrint: true, align: 'left' },
  { key: 'productRemark', label: '单品备注', defaultPrint: true, align: 'left' },
];

const ORDER_TEXT_PRODUCT_FIELDS = ORDER_PRODUCT_FIELDS.map((field) => {
  const textFieldPatch = {
    productName: { defaultBold: false },
    packWeight: { defaultPrint: true, defaultFontSize: FONT_SIZE_VALUE.SMALL },
    orderNumber: { defaultFontSize: FONT_SIZE_VALUE.SMALL },
    saleNumber: { defaultFontSize: FONT_SIZE_VALUE.SMALL },
    grossWeight: { defaultFontSize: FONT_SIZE_VALUE.SMALL },
    iceWeight: { defaultFontSize: FONT_SIZE_VALUE.SMALL },
    unitPrice: { defaultFontSize: FONT_SIZE_VALUE.SMALL },
    goodsAmount: { defaultPrint: true, defaultFontSize: FONT_SIZE_VALUE.SMALL },
    subtotal: { defaultBold: false },
    basketDesc: { defaultFontSize: FONT_SIZE_VALUE.SMALL },
    extraAmount: { defaultFontSize: FONT_SIZE_VALUE.SMALL },
    productRemark: { defaultFontSize: FONT_SIZE_VALUE.SMALL },
  };
  if (textFieldPatch[field.key]) {
    return { ...field, ...textFieldPatch[field.key] };
  }
  return field;
});

export const ORDER_TOTAL_FIELDS = [
  {
    key: 'totalNumberWeight',
    label: '总数量/总重量',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'depositBasketAmount',
    label: '押筐合计',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.SMALL,
    align: 'left',
  },
  {
    key: 'returnBasketAmount',
    label: '收筐合计',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.SMALL,
    align: 'left',
  },
  {
    key: 'chargeOrderFee',
    label: '三轮车费',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  { key: 'totalGoodsAmount', label: '总货款', defaultBold: true, align: 'left' },
  {
    key: 'totalAmount',
    label: '总计',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'discountAmount',
    label: '总优惠',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'payableAmount',
    label: '应付',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'paymentAmount',
    label: '实付',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'refundableAmount',
    label: '应退',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'deductionOtherOrderAmount',
    label: '抵扣赊欠',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'refundAmount',
    label: '实退',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'creditAmount',
    label: '本单下欠',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  { key: 'prestoreBalance', label: '预存结余', defaultBold: true, align: 'left' },
  {
    key: 'beforeCreditAmount',
    label: '前欠',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
  {
    key: 'buyerCreditAmount',
    label: '总欠',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.NORMAL,
    defaultBold: true,
    align: 'left',
  },
];

export const ORDER_END_FIELDS = [
  {
    key: 'createOrderName',
    label: '开票员',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  {
    key: 'createOrderTime',
    label: '开票时间',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  {
    key: 'createName',
    label: '收银员',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  {
    key: 'createTime',
    label: '收银时间',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  {
    key: 'salesManagerName',
    label: '销售经理',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  {
    key: 'salesManagerPhone',
    label: '销售经理电话',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  { key: 'address', label: '商行地址', defaultPrint: true, defaultFontSize: FONT_SIZE_VALUE.MINI },
  {
    key: 'stallTelephone',
    label: '联系方式',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  {
    key: 'printTime',
    label: '打印时间',
    defaultPrint: true,
    defaultFontSize: FONT_SIZE_VALUE.MINI,
  },
  { key: 'customContent', label: '自定义内容', defaultFontSize: FONT_SIZE_VALUE.MINI },
];

function normalizeBoolean(value, fallback = false) {
  return typeof value === 'boolean' ? value : fallback;
}

function normalizeRows(value, fallback = 3) {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  return Math.min(10, Math.max(1, Math.round(num)));
}

export function normalizeFontSize(value, fallback = DEFAULT_FIELD_FONT_SIZE) {
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  if ([1, 2, 3, 4, 5].includes(num)) return num;
  if (num === 11) return 1;
  if (num === 13) return 2;
  if (num === 14) return 3;
  if (num === 18) return 4;
  if (num === 26) return 5;
  return fallback;
}

export function findFieldByKey(list, key) {
  return (list || []).find((item) => item?.fieldName === key);
}

export function buildDefaultField(meta) {
  return {
    fieldName: meta.key,
    printFlag: !!(meta.required || meta.defaultPrint),
    fontSize: normalizeFontSize(meta.defaultFontSize, DEFAULT_FIELD_FONT_SIZE),
    boldFlag: !!meta.defaultBold,
    align: meta.align || 'left',
  };
}

export function normalizeFieldList(list, metas) {
  return metas.map((meta) => {
    const found = findFieldByKey(list, meta.key);
    const fallback = buildDefaultField(meta);
    return {
      fieldName: meta.key,
      printFlag: meta.required ? true : normalizeBoolean(found?.printFlag, fallback.printFlag),
      fontSize: normalizeFontSize(found?.fontSize, fallback.fontSize),
      boldFlag: normalizeBoolean(found?.boldFlag, fallback.boldFlag),
      align: meta.align || found?.align || fallback.align || 'left',
    };
  });
}

export function updateFieldList(list, key, patch, metas) {
  const normalized = normalizeFieldList(list, metas);
  return normalized.map((item) => {
    if (item.fieldName !== key) return item;
    const meta = metas.find((m) => m.key === key);
    return {
      ...item,
      ...patch,
      ...(meta?.required ? { printFlag: true } : {}),
    };
  });
}

export function normalizeTableHead(tableHead) {
  return {
    fieldName: tableHead?.fieldName || 'tableHead',
    printFlag: normalizeBoolean(tableHead?.printFlag, true),
    fontSize: normalizeFontSize(tableHead?.fontSize, DEFAULT_TITLE_FONT_SIZE),
    boldFlag: normalizeBoolean(tableHead?.boldFlag, true),
  };
}

export function normalizeMemoTemplate(data = {}) {
  return {
    headList: normalizeFieldList(data.headList, MEMO_HEAD_FIELDS),
    endList: normalizeFieldList(data.endList, MEMO_END_FIELDS),
    globalUnderline: normalizeBoolean(data.globalUnderline),
    showBatchCategory: normalizeBoolean(data.showBatchCategory, true),
    showReplenishArea: normalizeBoolean(data.showReplenishArea),
    replenishRows: normalizeRows(data.replenishRows),
    showBarcode: normalizeBoolean(data.showBarcode),
    showMasterBuyerName: normalizeBoolean(data.showMasterBuyerName),
    autoSyncStallQrcodeUrl: normalizeBoolean(data.autoSyncStallQrcodeUrl),
    qrcodeUrl: data.qrcodeUrl || '',
    qrcodeHint: data.qrcodeHint || '',
    tableTemplate: {
      tableHead: normalizeTableHead(data.tableTemplate?.tableHead),
      productList: normalizeFieldList(data.tableTemplate?.productList, MEMO_PRODUCT_FIELDS),
      totalList: normalizeFieldList(data.tableTemplate?.totalList, MEMO_TOTAL_FIELDS),
    },
    textTemplate: {
      fontSize: normalizeFontSize(data.textTemplate?.fontSize, DEFAULT_TITLE_FONT_SIZE),
      boldFlag: normalizeBoolean(data.textTemplate?.boldFlag, true),
      goodsAmountFlag: normalizeBoolean(data.textTemplate?.goodsAmountFlag, true),
      saleNumberWeightFlag: normalizeBoolean(data.textTemplate?.saleNumberWeightFlag, true),
    },
  };
}

export function normalizeOrderTemplate(data = {}) {
  return {
    headList: normalizeFieldList(data.headList, ORDER_HEAD_FIELDS),
    endList: normalizeFieldList(data.endList, ORDER_END_FIELDS),
    globalUnderline: normalizeBoolean(data.globalUnderline),
    customContent: data.customContent || '',
    showAllPhones: normalizeBoolean(data.showAllPhones),
    showAmountUnit: normalizeBoolean(data.showAmountUnit),
    showBatchCategory: normalizeBoolean(data.showBatchCategory, true),
    showFixedWeight: normalizeBoolean(data.showFixedWeight, true),
    showHandwriteArea: normalizeBoolean(data.showHandwriteArea),
    handwriteRows: normalizeRows(data.handwriteRows),
    showNonFixedWeight: normalizeBoolean(data.showNonFixedWeight, true),
    showWeightUnit: normalizeBoolean(data.showWeightUnit),
    showPriceUnit: normalizeBoolean(data.showPriceUnit),
    showTraceability: normalizeBoolean(data.showTraceability),
    showMasterBuyerName: normalizeBoolean(data.showMasterBuyerName),
    tableTemplate: {
      tableHead: normalizeTableHead(data.tableTemplate?.tableHead),
      productList: normalizeFieldList(data.tableTemplate?.productList, ORDER_PRODUCT_FIELDS),
      totalList: normalizeFieldList(data.tableTemplate?.totalList, ORDER_TOTAL_FIELDS),
    },
    textTemplate: {
      productList: normalizeFieldList(data.textTemplate?.productList, ORDER_TEXT_PRODUCT_FIELDS),
      totalList: normalizeFieldList(data.textTemplate?.totalList, ORDER_TOTAL_FIELDS),
    },
  };
}

export function cloneTemplate(template) {
  return JSON.parse(JSON.stringify(template || {}));
}

export function getPrintedLabels(list, metas) {
  const normalized = normalizeFieldList(list, metas);
  return normalized
    .filter((item) => item.printFlag)
    .map((item) => metas.find((meta) => meta.key === item.fieldName)?.label || item.fieldName);
}

export function getFieldStyle(field) {
  return {
    fontSize: `${
      FONT_SIZE_TO_PX[normalizeFontSize(field?.fontSize, DEFAULT_FIELD_FONT_SIZE)] || 14
    }px`,
    fontWeight: field?.boldFlag ? 700 : 400,
    textAlign: field?.align || 'left',
  };
}

export function getOperatorIdFromUser(userInfo) {
  return userInfo?.user_id || userInfo?.userId || userInfo?.id || userInfo?.personId;
}
